var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1008px",
        title: "产品库",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "opt" },
        [
          _c("div", { staticClass: "add", on: { click: _vm.add } }, [
            _c("img", {
              attrs: { src: require("@/assets/images/add.png"), alt: "" },
            }),
            _vm._v(" 新增 "),
          ]),
          _c(
            "BaseFilter",
            {
              attrs: { isActive: _vm.isActive, width: 438 },
              on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
            },
            [
              _c(
                "div",
                { staticClass: "filter" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { model: _vm.filterList, "label-width": "40px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "税号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: "请输入税号" },
                            model: {
                              value: _vm.filterList.hsCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterList, "hsCode", $$v)
                              },
                              expression: "filterList.hsCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "data" },
        [
          _c("BaseTable", {
            attrs: {
              height: 328,
              tableData: _vm.tableData,
              pageIndex: _vm.pager.pageIndex,
              pageSize: _vm.pager.pageSize,
              loading: _vm.loading,
              isPager: true,
              border: true,
            },
            on: {
              handlerRadio: _vm.handlerRadio,
              handlePageChange: _vm.handlePageChange,
              dblclick: _vm.dblclick,
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确定")]
          ),
        ]
      ),
      _c("ProductAddDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: { cancel: _vm.cancel2, ok: _vm.ok2 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }